import React, { Fragment } from 'react';
import { elements, colors } from '@peachjar/components';
import { css } from 'react-emotion';

import Radio from '../components/Radio';
import CharterSchoolErrorMessage from './CharterSchoolErrorMessage';

const { soil, blonde, jungle } = colors;
const { Paragraph } = elements.typography;

const styles = {
  validator: css`
    padding: 1rem;
    border: 1px solid ${soil};
    border-radius: 3px;
    margin-left: -5px;
    margin-top: 0.5rem;
    background-color: ${blonde};
    display: flex;
    flex-direction: column;
  `,
  link: css`
    color: ${jungle} !important;

    &:hover {
      color: #71c174 !important;
    }
  `,
};

const CharterSchoolRadios = ({
  isCharterSchoolProceeding,
  handleCharterSchoolRadioSelection,
}) => (
  <div className="mt-5">
    <div>
      <Paragraph>
        The NCES database tells us you are a charter school and part of a
        district. Do you want to sign up independent of your district?
      </Paragraph>
    </div>

    <div className="pt-3 layout-row layout-align-start-center">
      <label htmlFor="yes-onboardDistrict">
        <Radio
          id="yes-onboardDistrict"
          color="jungle"
          onClick={handleCharterSchoolRadioSelection(true)}
          checked={isCharterSchoolProceeding === true}
        />
        Yes
      </label>
      <label className="ml-3" htmlFor="no-onboardDistrict">
        <Radio
          id="no-onboardDistrict"
          color="jungle"
          onClick={handleCharterSchoolRadioSelection(false)}
          checked={isCharterSchoolProceeding === false}
        />
        No
      </label>
    </div>

    {isCharterSchoolProceeding === false && <CharterSchoolErrorMessage />}
  </div>
);

export default CharterSchoolRadios;



// WEBPACK FOOTER //
// ./src/Onboarding/Registration/onboarding/containers/SchoolRegistration/components/CharterSchoolRadios.jsx